import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "collection-status" }
const _hoisted_2 = { className: "user-address" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { className: "label" }, "Wallet address:", -1)
const _hoisted_4 = { className: "address" }
const _hoisted_5 = { className: "supply" }
const _hoisted_6 = { className: "current-sale" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Web3.userAddress), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Web3.totalSupply) + "/" + _toDisplayString(_ctx.Web3.maxSupply), 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.isSaleOpen ? (_ctx.Web3.isWhitelistMintEnabled ? 'Whitelist Only' : 'Open') : 'Closed'), 1)
  ]))
}